import { render, staticRenderFns } from "./NewWhatsappBusinessChannel.vue?vue&type=template&id=7a96a66f&scoped=true"
import script from "./NewWhatsappBusinessChannel.vue?vue&type=script&lang=js"
export * from "./NewWhatsappBusinessChannel.vue?vue&type=script&lang=js"
import style0 from "./NewWhatsappBusinessChannel.vue?vue&type=style&index=0&id=7a96a66f&prod&lang=scss&scoped=true"
import style1 from "./NewWhatsappBusinessChannel.vue?vue&type=style&index=1&id=7a96a66f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a96a66f",
  null
  
)

export default component.exports